import * as React from "react";
import { useBreakpoint, Breakpoint } from "../../hooks/useBreakpoint";

type Tone = "white" | "primary";

type Props = {
  n: string;
  tone?: Tone;
  /** Override the trailing rule width. Omit to track the viewport per-bp. */
  ruleWidth?: string;
  className?: string;
};

// The trailing rule shrinks with the viewport so it never overflows a narrow
// column (320px desktop would run off a 375px mobile screen). Internal — the
// width always follows the breakpoint, so no call-site overrides it normally.
const RULE_WIDTH_BY_BP: Record<Breakpoint, string> = {
  mobile: "180px",
  tablet: "240px",
  desktop: "320px",
};

export function Diamond({
  n,
  tone = "white",
  ruleWidth,
  className,
}: Props) {
  const bp = useBreakpoint();
  const rule = ruleWidth ?? RULE_WIDTH_BY_BP[bp];
  const toneClasses =
    tone === "white"
      ? { border: "border-white/30", text: "text-white", rule: "bg-white/30" }
      : { border: "border-primary/30", text: "text-primary", rule: "bg-primary/30" };

  return (
    <div className={["flex items-center gap-1", className].filter(Boolean).join(" ")}>
      <div
        className={[
          "relative h-8 w-8 rotate-45 border mr-[2px]",
          toneClasses.border,
          toneClasses.text,
        ].join(" ")}
      >
        <div className="absolute inset-0 flex items-center justify-center -rotate-45 text-[12px] font-medium">
          {n}
        </div>
      </div>
      <div
        className={["h-px", toneClasses.rule].join(" ")}
        style={{ width: rule }}
      />
    </div>
  );
}
